<loading-spinner [show]="isLoadingSaveBl" [config]="{ fullScreenBackdrop: true }"></loading-spinner>

<div class="h-100" *ngIf="entrySummary && entrySummary.referenceNumber && isDesktop">
  <div class="h-100" [ngClass]="{ 'form-scroll': !isOnSummary }">
    <div class="scrollable-wrapper">
      <div [ngClass]="{ 'fix-scroll': !isOnSummary }">
        <ng-content select="[header-validation-payment-desktop]"></ng-content>
        <ng-content select="[documents-strip-desktop]"></ng-content>

        <div class="es-container desktop">
          <internal-notes-card
            *ngIf="!!entrySummary.internalNotes && !isSidebar"
            [product]="entrySummary"
            [isIsfPlacement]="false"
          ></internal-notes-card>

          <es-summary-success-header-desktop
            *ngIf="!isShowInfo"
            [entrySummary]="entrySummary"
            [isEditMode]="isEditModeOn"
            [cbpLogMessages]="cbpLogMessages"
            [duties]="dutiesValue"
            [attachedDocuments]="attachedDocuments"
            [paymentBreakdown]="paymentBreakdown"
            [isMonthlyInstantDuties]="isMonthlyInstantDuties"
            [isLoading]="isLoading"
            (messageToBroker)="onMessageToBroker()"
            (duplicate)="onDuplicate()"
            (print)="onPrint(true)"
            (createDeliveryOrder)="onCreateDeliveryOrder()"
            (closeNotification)="isEditMode = !isEditMode"
            (cancelPayment)="onCancelPayment.emit()"
            (errorPayment)="onErrorPayment.emit($event)"
            (errorCustomPayment)="onErrorPayment.emit($event)"
            (successPayment)="onSuccessPayment.emit($event)"
            (confirmDuties)="onConfirmDuties.emit()"
            (openChat)="onOpenChat()"
            [isShowInsuranceIcon]="true"
            (addInsurance)="openMarineInsuranceQuoteForm()"
          ></es-summary-success-header-desktop>

          <ng-container *ngIf="!isSidebar">
            <div
              class="es-container-marine-insurance"
              *ngIf="!isCreating && !isCreatingInvoice && !isCreateBL && !(isInsuranceLoading | async)"
            >
              <app-marine-insurance-quote-pricing-card
                *ngIf="
                  !(isInsuranceAvailable | async) &&
                  !(isProviderWasDown | async) &&
                  isEsSent &&
                  !paidOrSentPaymentStates.includes((currentInsurance | async)?.paymentState)
                "
                [marineInsurance]="currentInsurance | async"
                [pendingBills]="currentInsurancePendingBills | async"
                [parent]="entrySummary"
                (edit)="openMarineInsuranceQuoteForm(true)"
              ></app-marine-insurance-quote-pricing-card>

              <app-marine-insurance-quote-view-card
                *ngIf="isProviderWasDown | async"
                [marineInsurance]="currentInsurance | async"
                [documents]="currentInsuranceDocuments | async"
                [entity]="enumMarineInsuranceEntityType.ENTRY_SUMMARY"
                [state]="entrySummary.state"
                [isShowUpdated]="
                  !!(currentInsurance | async)?.updatedInsuredValue?.insuredAmount &&
                  (!(currentInsurancePendingBills | async)?.items?.length || (currentInsurance | async)?.partiallyRefundConfirmed)
                "
                [isPendingAdminApproval]="
                  (!(currentInsurancePendingBills | async)?.items?.length &&
                    (currentInsurance | async)?.pendingPaymentAction === enumMarineInsurancePendingPaymentAction.ADDITIONAL_PAYMENT) ||
                  ((currentInsurancePendingBills | async)?.items?.length && (currentInsurance | async)?.partiallyRefundConfirmed)
                "
                (edit)="openMarineInsuranceQuoteForm(true)"
              ></app-marine-insurance-quote-view-card>

              <app-marine-insurance-quote-updated-pricing-card
                *ngIf="
                  !(isInsuranceAvailable | async) &&
                  isEsSent &&
                  paidOrSentPaymentStates.includes((currentInsurance | async)?.paymentState) &&
                  (currentInsurance | async)?.pendingPaymentAction === enumMarineInsurancePendingPaymentAction.ADDITIONAL_PAYMENT &&
                  (currentInsurancePendingBills | async)?.items?.length
                "
                [marineInsurance]="currentInsurance | async"
                [pendingBills]="currentInsurancePendingBills | async"
              ></app-marine-insurance-quote-updated-pricing-card>
            </div>
          </ng-container>

          <es-shipment-summary-desktop
            [entrySummary]="entrySummary"
            [isCanEdit]="isEditModeOn || !isOnSummary"
            [isTruckModeAvailable]="isTruckModeAvailable"
            [company]="company"
            [isShowFirstLine]="isOnSummary"
            (editDetails)="onEditDetails('isMainInfo')"
            (editFrom)="onEditDetails('isFromInfo')"
            (editTo)="onEditDetails('isToInfo')"
            (editVia)="onEditDetails('isViaInfo')"
            (editMF)="onEditEntity(entrySummary?.importer, initCompanyEntity(), enumEntityModelCode.IMPORTER, 'importer')"
            (editDutiesPaymentType)="onEditDutiesType()"
            (editShipmentType)="onEditShipmentDetails()"
          ></es-shipment-summary-desktop>

          <es-shipment-details-desktop
            *ngIf="isCreating && !isCreatingInvoice"
            [entrySummary]="entrySummary"
            [formGroup]="fg"
            (editImporter)="onEditEntity(entrySummary?.importer, initCompanyEntity(), enumEntityModelCode.IMPORTER, 'importer')"
          ></es-shipment-details-desktop>

          <ng-container *ngIf="!isSidebar">
            <div class="es-container-marine-insurance" *ngIf="isCreating && !(isInsuranceLoading | async) && !isLoading">
              <app-marine-insurance-quote-view-card
                *ngIf="
                  (!(isInsuranceAvailable | async) && !isEsSent) ||
                  paidOrSentPaymentStates.includes((currentInsurance | async)?.paymentState) ||
                  (currentInsurance | async)?.pendingPaymentAction === enumMarineInsurancePendingPaymentAction.ADDITIONAL_PAYMENT
                "
                [marineInsurance]="currentInsurance | async"
                [documents]="currentInsuranceDocuments | async"
                [entity]="enumMarineInsuranceEntityType.ENTRY_SUMMARY"
                [state]="entrySummary.state"
                [isShowUpdated]="
                  !!(currentInsurance | async)?.updatedInsuredValue?.insuredAmount &&
                  (!(currentInsurancePendingBills | async)?.items?.length || (currentInsurance | async)?.partiallyRefundConfirmed)
                "
                [isPendingAdminApproval]="
                  (!(currentInsurancePendingBills | async)?.items?.length &&
                    (currentInsurance | async)?.pendingPaymentAction === enumMarineInsurancePendingPaymentAction.ADDITIONAL_PAYMENT) ||
                  ((currentInsurancePendingBills | async)?.items?.length && (currentInsurance | async)?.partiallyRefundConfirmed)
                "
                (edit)="openMarineInsuranceQuoteForm(true)"
              ></app-marine-insurance-quote-view-card>
            </div>
          </ng-container>

          <desktop-upload-entry-summary-documents
            *ngIf="(isOnSummary || isCreating) && !isHasEsOcrRedesign"
            [company]="company"
            [entrySummary]="entrySummary"
            [attachedDocuments]="attachedDocuments"
            [isCanEdit]="isEditModeOn || isCanEdit"
            [isSidebar]="isSidebar"
            [isRequiredDocument]="entrySummary?.submissionType === enumEntrySummarySubmissionType.BROKER_ASSISTED"
            [hasPendingBills]="pendingBills.length > 0"
            (downloadAllFiles)="onDownloadAllFiles($event)"
          ></desktop-upload-entry-summary-documents>

          <es-bill-of-lading-view-desktop
            *ngFor="let shipment of currentShipments; trackBy: trackByBLFn; let i = index"
            [shipment]="shipment"
            [transportationMode]="entrySummary.transportationMode"
            [entrySummary]="entrySummary"
            [attachedDocuments]="attachedDocuments"
            [incoterms]="incoterms"
            [currencies]="currencies"
            [currencyRate]="currencyRate"
            [company]="company"
            [isCanAdd]="isCanAddBL"
            [isCanEdit]="isEditModeOn && !isCreateBL"
            [isCanRemove]="isEditModeOn && currentShipments.length > 1"
            [isRequiredDocument]="entrySummary?.submissionType === enumEntrySummarySubmissionType.BROKER_ASSISTED && !isTruck"
            [isRequiredInvoiceDocument]="entrySummary?.submissionType === enumEntrySummarySubmissionType.BROKER_ASSISTED"
            [isBLNewlyCreated]="isBLNewlyCreated(shipment.id)"
            [newlyCreatedInvoicesIds]="newlyCreatedInvoicesIds"
            [showInnerContainer]="isShowBLBody(shipment)"
            [isCreatingInvoice]="isShowBLEditableCardDesktop(shipment)"
            [invoiceFg]="invoiceFg"
            [isBatchES]="isSidebar"
            [isShowAddNewInvoice]="isShowBLAddCardDesktop(shipment) && isInvoiceValid(shipment)"
            [isCanBulkDelete]="isEditModeOn && !isCreateBL"
            (addNewBl)="editShipment()"
            (editInvoice)="onEditInvoice($event)"
            (updateInvoice)="onUpdateInvoice($event)"
            (removeInvoiceSource)="onRemoveInvoice($event.shipmentId, $event.invoiceId)"
            (editManufacturer)="onEditManufacturer($event)"
            (editSeller)="onEditShipmentEntity(shipment?.seller, null, enumEntityModelCode.SELLER, 'seller', shipment)"
            (editConsignee)="
              onEditShipmentEntity(shipment?.consignee, entrySummary?.importer, enumEntityModelCode.CONSIGNEE, 'consignee', shipment)
            "
            (editBuyer)="onEditShipmentEntity(shipment?.buyer, entrySummary?.importer, enumEntityModelCode.BUYER, 'buyer', shipment)"
            (addLineItem)="onEditHTS($event)"
            (editLineItem)="onEditHTS($event)"
            [isShowFinalize]="true"
            (finalize)="onFinalize($event)"
            (deleteLineItem)="onDeleteHTS($event)"
            (linesDeleted)="onLinesBulkDeleted()"
            (editTermsOfSale)="onEditTermsOfSale(shipment)"
            (editBl)="onEditBL(shipment)"
            (removeBl)="onRemoveBL(shipment.id)"
            (savedInvoice)="onInvoiceSaved()"
            (replaceInvoice)="onReplaceInvoice(shipment.id, $event)"
            (documentStateUpdate)="onDocumentStateUpdate($event)"
            (addNewInvoice)="addNewInvoice($event)"
            (clearInvoice)="onClearInvoice()"
            (fileUploaded)="onFinishOCR()"
            (reviewInvoice)="onReviewInvoice($event)"
          >
            <ng-container body>
              <div
                class="add-new-invoice"
                *ngIf="isShowBLAddCardDesktop(shipment) && isInvoiceValid(shipment)"
                (click)="addNewInvoice(shipment?.id)"
              >
                <span>+ {{ "ENTRY_SUMMARY.ADD_NEW_INVOICE" | translate }}</span>
              </div>

              <ng-container *ngIf="isShowBLEditableCardDesktop(shipment) && !isHasEsOcrRedesign">
                <ng-container>
                  <es-invoice-add-ocr
                    [rootEntityId]="entrySummary.id"
                    [rootEntityType]="enumDocumentRootEntityType.ENTRY_SUMMARY"
                    [billOfLadingId]="shipment?.id"
                    [existingFile]="newlyCreatedInvoicesFile"
                    (ocrCompleted)="onFinishOCR()"
                    (editManually)="onFinishOCR()"
                  ></es-invoice-add-ocr>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="checkIsShowOcrConfirm(shipment) && !isEditInvoice && !isHasEsOcrRedesign">
                <div class="bl-ocr-confirm">
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="is-ocr-confirmed-{{ shipment.id }}"
                      [formControl]="isOcrConfirmCtrls.controls[i].get('confirmed')"
                    />
                    <label class="custom-control-label" for="is-ocr-confirmed-{{ shipment.id }}">{{ "CONFIRM_OCR" | translate }}</label>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </es-bill-of-lading-view-desktop>

          <div #newBLForm>
            <es-bill-of-lading-edit-desktop
              *ngIf="isNewShipmentLoaded && isCreateBL"
              [formGroup]="createBLFormGroup"
              [entrySummary]="entrySummary"
              [shipment]="newShipment"
              [transportationMode]="entrySummary.transportationMode"
              [isRequiredDocument]="entrySummary?.submissionType === enumEntrySummarySubmissionType.BROKER_ASSISTED && !isTruck"
              [isShowHeader]="false"
              [isShowSaveBtn]="true"
              (saveBL)="onSubmitNewBL()"
            ></es-bill-of-lading-edit-desktop>
          </div>

          <ng-container *ngIf="!isSidebar">
            <div class="es-container-marine-insurance" *ngIf="!isCreating && !isCreatingInvoice && !(isInsuranceLoading | async)">
              <app-marine-insurance-quote-view-card
                *ngIf="
                  (!(isInsuranceAvailable | async) && !isEsSent) ||
                  paidOrSentPaymentStates.includes((currentInsurance | async)?.paymentState) ||
                  (currentInsurance | async)?.pendingPaymentAction === enumMarineInsurancePendingPaymentAction.ADDITIONAL_PAYMENT
                "
                [marineInsurance]="currentInsurance | async"
                [documents]="currentInsuranceDocuments | async"
                [entity]="enumMarineInsuranceEntityType.ENTRY_SUMMARY"
                [state]="entrySummary.state"
                [isShowUpdated]="
                  !!(currentInsurance | async)?.updatedInsuredValue?.insuredAmount &&
                  (!(currentInsurancePendingBills | async)?.items?.length || (currentInsurance | async)?.partiallyRefundConfirmed)
                "
                [isPendingAdminApproval]="
                  (!(currentInsurancePendingBills | async)?.items?.length &&
                    (currentInsurance | async)?.pendingPaymentAction === enumMarineInsurancePendingPaymentAction.ADDITIONAL_PAYMENT) ||
                  ((currentInsurancePendingBills | async)?.items?.length && (currentInsurance | async)?.partiallyRefundConfirmed)
                "
                (edit)="openMarineInsuranceQuoteForm(true)"
              ></app-marine-insurance-quote-view-card>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="container-actions container-actions-summary d-print-none" *ngIf="!isOnSummary">
      <app-primary-button
        *ngIf="isCreating"
        [isSkip]="false"
        [isCentered]="true"
        (click)="saveIntermediateDesktopData()"
      ></app-primary-button>

      <app-primary-button
        *ngIf="isCreatingInvoice"
        [isSkip]="false"
        [isCentered]="true"
        [disabled]="isCreatingInvoiceStepInvalid()"
        (click)="saveBLData()"
      ></app-primary-button>
    </div>

    <ng-content select="[footer-full-desktop]"></ng-content>
  </div>
</div>

<div class="h-100" *ngIf="entrySummary && entrySummary.referenceNumber && !isDesktop">
  <div class="es-payment-card-mobile d-lg-none" *ngIf="pendingBills.length">
    <div class="es-payment-card">
      <app-payment-breakdown [pendingBills]="pendingBills" [isMobileView]="true"></app-payment-breakdown>
    </div>
  </div>

  <div class="es-container">
    <div class="form-scroll without-mobile-header" [ngClass]="formScrollClass">
      <ng-template [ngIf]="!isPrinting" [ngIfThen]="scrollableContent" [ngIfElse]="content"></ng-template>

      <ng-template #scrollableContent>
        <div class="scrollable-wrapper">
          <ng-template [ngIf]="!isPrinting" [ngIfThen]="content"></ng-template>
        </div>
      </ng-template>

      <ng-template #content>
        <div *ngIf="!isShowPaymentResult" class="fix-scroll">
          <div class="inner-container">
            <info
              subTitle="INFO.ES_STATUS.SUB_TITLE"
              *ngIf="isShowInfo"
              [title]="('LABELS.ENTRY_SUMMARY' | translate) + ': ' + entrySummary.referenceNumber || ''"
            >
              <es-actions
                [es]="entrySummary"
                [state]="entrySummary.state"
                [paymentState]="entrySummary.paymentState"
                [viewEs]="false"
                [showPrint]="true"
                [iconColor]="'default'"
                [showGoToChat]="false"
                [showDelivery]="!isTruck"
                (update)="goToDashboard()"
                (print)="onPrint()"
              ></es-actions>
            </info>

            <internal-notes-card
              *ngIf="!!entrySummary.internalNotes"
              [product]="entrySummary"
              [isIsfPlacement]="false"
            ></internal-notes-card>

            <div *ngIf="isShowDocumentsButton">
              <button class="btn btn-link d-print-none" type="button" (click)="isOpenFiles = !isOpenFiles">
                {{ (isOpenFiles ? "BUTTON.CLOSE_DOCUMENTS" : "BUTTON.OPEN_DOCUMENTS") | translate }}
              </button>
            </div>
            <es-card-notice
              [(isOpenFiles)]="isOpenFiles"
              [es]="entrySummary"
              [disableActions]="false"
              [showChatWithBroker]="showChatWithBroker"
              [pendingBills]="pendingBills"
              (goToBrokerChat)="goToBrokerChat()"
              (messagesLoaded)="afterMessagesLoaded()"
            >
              <es-actions
                [es]="entrySummary"
                [state]="entrySummary.state"
                [paymentState]="entrySummary.paymentState"
                [viewEs]="false"
                [showPrint]="true"
                [showGoToChat]="true"
                [iconColor]="'white'"
                [showDelivery]="!isTruck"
                (update)="goToDashboard()"
                (print)="onPrint()"
              ></es-actions>
            </es-card-notice>
            <es-details
              [deliveryOrdersInfo]="deliveryOrdersInfo"
              [onlyLastVersionForFormDocuments]="true"
              [entrySummary]="entrySummary"
              [attachedDocuments]="attachedDocuments"
              [isCanEdit]="isCanEdit"
              [isCanEditBond]="isCanEdit"
              [dutiesValue]="dutiesValue"
              [isShowDocuments]="isOpenFiles"
              [isCanUploadDocuments]="true"
              [allValidationMessages]="validationMessages$ | async"
              [companyPaymentType]="companyPaymentType"
              [isShowActions]="isTablet"
              [pendingBills]="pendingBills"
              [canceledBills]="canceledBills"
              [canUploadPunToCompany]="true"
              [isInsuranceAvailable]="isInsuranceAvailable | async"
              [isProviderWasDown]="isProviderWasDown | async"
              [isInsuranceLoading]="isInsuranceLoading | async"
              [currentInsurance]="currentInsurance | async"
              [currentInsuranceDocuments]="currentInsuranceDocuments | async"
              [currentInsurancePendingBills]="currentInsurancePendingBills | async"
              [uploadCompanyFile]="onUploadCompanyFile()"
              [uploadFile]="onUploadFile()"
              [removeFile]="onRemoveFile()"
              (editShipmentData)="editShipmentData()"
              (editImporter)="editImporter()"
              (editBond)="editBond()"
              (editShipment)="editShipment($event)"
              (editShipmentConsignee)="editShipmentConsignee($event)"
              (editShipmentBuyer)="editShipmentBuyer($event)"
              (editSupplier)="editSupplier($event)"
              (editInvoice)="editInvoice($event.shipmentId, $event.invoiceId)"
              (removeInvoice)="onRemoveInvoice($event.shipmentId, $event.invoiceId)"
              (editInvoices)="editInvoices($event)"
              (removeShipment)="onRemoveShipment($event)"
              (documentStateUpdate)="onDocumentStateUpdate($event)"
              (poaSidebarRequest)="onPoaSidebarRequest($event)"
            >
              <ng-content apply-coupon-card select="[apply-coupon-card]"></ng-content>
              <ng-content payment-card-actions select="[payment-card-actions]"></ng-content>
            </es-details>
          </div>
          <ng-template [ngIf]="isTablet">
            <ng-content select="[footer-mobile]"></ng-content>
          </ng-template>
        </div>
        <div *ngIf="isShowPaymentResult" class="fix-scroll">
          <div class="inner-container">
            <app-result
              *ngIf="entrySummary && entrySummary.referenceNumber"
              [currES]="entrySummary"
              [error]="paymentError"
              deliveryRouterLink="delivery-order"
              (goToEdit)="hidePaymentResult()"
              [deliveryOrders]="deliveryOrders"
              [affiliateData]="affiliateData"
            ></app-result>
          </div>
        </div>
      </ng-template>
    </div>
    <ng-template [ngIf]="!isTablet && !isPrinting">
      <ng-content select="[footer-desktop]"></ng-content>
    </ng-template>
  </div>
</div>

<missing-fields [code]="'LABELS.ENTRY_SUMMARY'" (decline)="declineModal()" (confirm)="clearStep()"></missing-fields>

<custom-modal [header]="'LABELS.CURRENCY'" [type]="'warning'" [(open)]="openCurrencyWarningRateModal">
  <div
    [innerHTML]="
      'ENTRY_SUMMARY.CURRENCY_WARNING_MODAL.BODY'
        | translate
          : { currency: currencyWarningRateModalData.currency, exportDate: currencyWarningRateModalData.exportDate | customDateByUtc }
    "
  ></div>
  <button footer-action class="btn-secondary btn" type="button" (click)="openCurrencyWarningRateModal = false">
    {{ "BUTTON.OK" | translate }}
  </button>
</custom-modal>

<custom-modal [header]="'INVOICES_CONFIRMATION'" [(open)]="openOcrAllConfirmModal">
  <div class="bl-ocr-confirm bl-ocr-confirm-all">
    <div class="custom-control custom-checkbox">
      <input type="checkbox" class="custom-control-input" id="is-all-ocr-confirmed" [formControl]="isAllOcrConfirmCtrl" />
      <label class="custom-control-label" for="is-all-ocr-confirmed">{{ "CONFIRM_OCR_ALL" | translate }}</label>
    </div>
  </div>

  <button footer-action class="btn btn-primary bl-ocr-confirm-cancel" type="button" (click)="openOcrAllConfirmModal = false">
    {{ "BACK_TO_REVIEW" | translate }}
  </button>
  <button
    footer-action
    class="btn btn-primary bl-ocr-confirm-save"
    type="button"
    [disabled]="isAllOcrConfirmCtrl.invalid"
    (click)="saveIntermediateDesktopData()"
  >
    <span class="d-flex align-items-center">
      {{ "BUTTON.CONTINUE" | translate }}

      <img class="ml-2" src="assets/icons/icon_arrow_right_sm_white.svg" />
    </span>
  </button>
</custom-modal>

<custom-modal
  size="lg"
  [header]="('ENTRY_SUMMARY.UPLOAD_BL' | translate) + ' #' + (blModalShipmentIndex + 1)"
  [(open)]="isOpenAddBillOfLadingModal"
>
  <div class="upload-bl-modal">
    <div class="upload-bl-modal__information-box">
      <p class="upload-bl-modal__information-box__description">
        {{ "ENTRY_SUMMARY.SHIPMENT_RELATED_DOCS_INFO.DESCRIPTION" | translate }}
      </p>
      <span class="upload-bl-modal__information-box__label">{{ "ENTRY_SUMMARY.SHIPMENT_RELATED_DOCS_INFO.LABEL" | translate }}</span>
    </div>

    <div class="upload-bl-modal__body">
      <app-es-documents-bl-box
        [index]="blModalShipmentIndex"
        [entrySummary]="entrySummary"
        [shipment]="blModalShipment"
        [additionalDocumentsOptions]="additionalBlModalDocsOptions"
        [entryDocuments]="blModalDocuments"
        [skipOcrScanControl]="blModalSkipOcrScanControl"
        [isBillOfLadingRequired]="isBillOfLadingRequired"
        [isShowMultipleBlsHint]="true"
        [isShowFloatingTitle]="false"
        [isShowDeleteBlButton]="false"
        theme="highlighted"
        (upload)="onAddBlModalDocument($event)"
        (delete)="onRemoveBlModalDocument($event)"
        (stateUpdate)="updateBlModalDocumentState($event)"
        (addOtherDocument)="onAddOtherBlModalDocument($event)"
        (uploadNewDocument)="onUploadNewBlModalDocument($event)"
        (inputClick)="onBlModalInputClick()"
      ></app-es-documents-bl-box>

      <input
        class="d-none"
        type="file"
        #additionalDocumentsInput
        [accept]="allowedFileMimes"
        (change)="onAddOtherBlDocumentChange($event)"
      />

      <custom-toast
        type="alert"
        [message]="errorMessage"
        [duration]="0"
        [open]="isShowInvalidFileToast"
        (close)="onCloseInvalidFileToast()"
      >
        <button action-button class="custom-toast__action-button btn btn-link-outlined" (click)="onReplaceBlModalDoc()">
          {{ "BUTTON.REPLACE" | translate }}
        </button>
      </custom-toast>

      <button
        footer-action
        class="btn btn-primary btn-square btn-lg"
        type="button"
        [disabled]="isBlModalContinueDisabled"
        (click)="onSaveBlModal()"
      >
        {{ "BUTTON.CONTINUE" | translate }}
      </button>
    </div>
  </div>
</custom-modal>

<custom-modal [(open)]="isOpenRemainingRequiredModal" [header]="'ENTRY_SUMMARY.REQUIRED_DOCUMENT_MISSING_MODAL.HEADER'">
  <span
    [innerHTML]="'ENTRY_SUMMARY.REQUIRED_DOCUMENT_MISSING_MODAL.BODY' | translate : { documentName: singleBlMissingRequiredDocumentNames }"
  ></span>
  <div footer-action class="d-flex justify-content-between w-100">
    <button type="button" class="btn btn-outline-bordered btn-square" (click)="setIsOpenRemainingRequiredModal(false)">
      {{ "BUTTON.BACK_TO_UPLOAD" | translate }}
    </button>
    <button type="button" class="es-documents__continue-button btn btn-primary btn-square" (click)="onSaveBlModal(true)">
      <span>{{ "BUTTON.CONTINUE" | translate }}</span>
      <img src="assets/icons/icon_arrow_right_sm_white.svg" />
    </button>
  </div>
</custom-modal>
